var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 32,
    viewBox: "0 0 125 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32086 24.3001C11.5754 29.3182 22.3346 30.6797 35.3829 29.8748C56.5638 28.5682 76.3287 22.5696 94.8904 16.6459C99.8379 15.0671 104.536 13.052 108.903 11.0068",
    stroke: "#F0CD4E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.854 9.13568C101.457 8.63861 106.968 6.90982 112.522 6.00392C115.383 5.53721 118.192 5.03841 120.988 4.26526C121.555 4.10852 123.862 3.15071 122.617 4.52788C119.836 7.60438 116.373 9.94307 113.47 12.8783C111.735 14.6333 110.457 17.7391 108.614 19.1066",
    stroke: "#F0CD4E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
};

export { SvgArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI1IiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMTI1IDMyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMi4zMjA4NiAyNC4zMDAxQzExLjU3NTQgMjkuMzE4MiAyMi4zMzQ2IDMwLjY3OTcgMzUuMzgyOSAyOS44NzQ4QzU2LjU2MzggMjguNTY4MiA3Ni4zMjg3IDIyLjU2OTYgOTQuODkwNCAxNi42NDU5Qzk5LjgzNzkgMTUuMDY3MSAxMDQuNTM2IDEzLjA1MiAxMDguOTAzIDExLjAwNjgiIHN0cm9rZT0iI0YwQ0Q0RSIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTk1Ljg1NCA5LjEzNTY4QzEwMS40NTcgOC42Mzg2MSAxMDYuOTY4IDYuOTA5ODIgMTEyLjUyMiA2LjAwMzkyQzExNS4zODMgNS41MzcyMSAxMTguMTkyIDUuMDM4NDEgMTIwLjk4OCA0LjI2NTI2QzEyMS41NTUgNC4xMDg1MiAxMjMuODYyIDMuMTUwNzEgMTIyLjYxNyA0LjUyNzg4QzExOS44MzYgNy42MDQzOCAxMTYuMzczIDkuOTQzMDcgMTEzLjQ3IDEyLjg3ODNDMTExLjczNSAxNC42MzMzIDExMC40NTcgMTcuNzM5MSAxMDguNjE0IDE5LjEwNjYiIHN0cm9rZT0iI0YwQ0Q0RSIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";